module.exports = __webpack_public_path__ + "../resources/images/illustration_balloon-6e4efed12986c1beff8b212fcb36dab7.svg";